import React from 'react';
import { Outlet } from 'react-router-dom';

import { AuthenticatedTemplate, MsalProvider } from '@azure/msal-react';
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { CssBaseline, ThemeProvider } from '@mui/material';

import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import ErrorMessage from "./components/ui/error/ErrorMessage";
import ErrorSnackbar from './components/ui/messageBanners/ErrorSnackBar';
import LogoutBanner from './components/ui/messageBanners/LogoutBanner';
import SuccessSnackbar from './components/ui/messageBanners/SuccessSnackbar';
import { msalInstance } from './masl/authConfig';
import Masl from './masl/Masl';
import { appTheme } from './themes/theme';
import { appInsights, reactPlugin } from "./ApplicationInsightsService";

import classes from './app.module.css';

const App = () => {

    return (
        <MsalProvider instance={msalInstance}>
            <Masl />

            <div className={classes.wrapper}>
                <ThemeProvider theme={appTheme}>
                    <div className={classes.app}>
                        <CssBaseline enableColorScheme />

                        <div className={classes.header}>
                            <Header />
                        </div>

                        <div className={classes.content}>
                            {/* https://learn.microsoft.com/en-us/azure/azure-monitor/app/javascript-framework-extensions?tabs=react */}
                            <AppInsightsErrorBoundary
                                onError={() => <ErrorMessage appInsights={appInsights}/>}
                                appInsights={reactPlugin}>
                                <div className={classes.content}>
                                    <div className={classes.outletWrapper}>
                                        <AuthenticatedTemplate>
                                            <Outlet />
                                        </AuthenticatedTemplate>
                                    </div>
                                </div>
                                <SuccessSnackbar />
                                <ErrorSnackbar />
                                <LogoutBanner />

                            </AppInsightsErrorBoundary>
                        </div>
                        <Footer />
                    </div>
                </ThemeProvider>
            </div>
        </MsalProvider>
    );
};

export default App;